var em = function em(px) {
  return px / 16 + "em";
};

var mountMedia = function mountMedia(val) {
  return "@media screen and (max-width: " + em(val) + ")";
};

export var breakpoints = {
  mobile: 630,
  tablet: 920,
  desktop: 1120
};

if (typeof breakpoints !== 'undefined' && breakpoints && breakpoints === Object(breakpoints) && Object.isExtensible(breakpoints) && !Object.prototype.hasOwnProperty.call(breakpoints, '__filemeta')) {
  Object.defineProperty(breakpoints, '__filemeta', {
    configurable: true,
    value: {
      name: "breakpoints",
      filename: "node_modules/gatsby-theme-docz/src/theme/breakpoints.js"
    }
  });
}

export var media = {
  mobile: mountMedia(breakpoints.mobile),
  tablet: mountMedia(breakpoints.tablet),
  desktop: mountMedia(breakpoints.desktop)
};

if (typeof media !== 'undefined' && media && media === Object(media) && Object.isExtensible(media) && !Object.prototype.hasOwnProperty.call(media, '__filemeta')) {
  Object.defineProperty(media, '__filemeta', {
    configurable: true,
    value: {
      name: "media",
      filename: "node_modules/gatsby-theme-docz/src/theme/breakpoints.js"
    }
  });
}